import React, { ChangeEvent, ReactElement } from 'react'
import styled from 'styled-components'
import FieldStyles from '../components/FieldStyles'

export interface INumberFieldProps {
  name?: string
  placeholder?: string
  isError?: boolean
  step?: number
  label?: string
  onChange: (number: number | null) => void
  value: number | null
  minimumValue?: number
  maximumValue?: number
  className?: string
  subtitle?: string
  disabled?: boolean
}

const StyledInput = styled.input`
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
`

function NumberField(props: INumberFieldProps): ReactElement {
  const {
    name,
    placeholder,
    isError,
    step = 1,
    label,
    onChange,
    value,
    minimumValue = 1,
    maximumValue,
    className,
    subtitle,
    disabled,
  } = props

  const changeHandler = (event: ChangeEvent<HTMLInputElement>): void => {
    const number = parseFloat(event.target.value)
    const max = maximumValue ? number <= maximumValue : true

    if (number >= minimumValue && max) {
      onChange(number)
    } else if (Number.isNaN(number)) {
      onChange(null)
    }
  }

  return (
    <FieldStyles label={label} subtitle={subtitle}>
      <StyledInput
        type="number"
        step={step}
        name={name}
        placeholder={placeholder}
        className={`${className} styled-input ${isError && 'error'}`}
        onChange={changeHandler}
        value={value || value === 0 ? value : ''}
        disabled={disabled}
      />
    </FieldStyles>
  )
}
export default NumberField
